// Name1 
import { Row, Col, Button, jsonToQueryString, DeleteButton, useCRUDController, message, LucideIcon, convertResponsesToFormColumnMap, getValueByCode } from './ot'
import { useTranslation } from 'react-i18next'
import CrmDashboard from '../crm_base/crm_dashboard'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { render } from 'less';
import BaseCardView1_8 from './base_card_view_1_8';
const Name1 = ({
    propsCategoryName = "",
    propsCategoryTitle = "",
    createApiRoute = '/utility/document/_2',
    showCreateButtontext, // page模式建立按鈕是否顯示
    propsPrimaryColorName = 'green',
    propsPrimaryColor = '#14b8a6',
    propsSecodaryColor = '#22c55e',
    propsPageTitleColor,
    propsPageTitleFontSize = '1.875rem',
    propsPageTitleFontWeight = 700,
    propsPageTitleLineHeight = '1.2',
    propsCreateButtonTextColor = '#ffffff',
    propsCreateButtonFontSize = '14px',
    propsCreateButtonFontWeight = 500,
    propsDescriptionColor = '#475569',
    propsDescriptionFontSize = '14px',
    propsDescriptionLineHeight = '1.7',
    editPageFrontendRoute = "/utility/document/_3",
    mainApiRoute = '/utility/document/base_view', //資料主要顯示的API
    propsGetBaseCardViewData,
    propsGetBaseListViewData,
    propsGetCardFileId,
    propsCreateButtonText,
    propsActionTextConfig = {},
    propsFeedbackTextConfig = {},
    propsNameFieldCode = '名稱',
    propsDescriptionFieldCode = '描述',
    propsDateFormat = 'YYYY-MM-DD',
    propsFallbackText = '-',
    propsOperationColumnTitle = '操作',
    propsOperationColumnWidth = 100,
    treeFilterTitle = '分類篩選',
    searchTextConfig = {},
    viewModeTextConfig = {},
    categoryTabTextConfig = {},
    propsRenderCardExtraContent,
    propsRenderListExtraContent,
    responseApiRoute = '/utility/response/cache',
    dbCoverIdName = "document_id",
    baseCardView1_2PropsSrc = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s", // 顯示預設圖片
    stats = [{
        value: 90,
        label: "總範本數",
        color: "#6366f1",
        backgroundColor: "bg-white",
        icon: <LucideIcon name="FileText" />,
        iconPosition: "right",
        animationDuration: 2000,
        animationDelay: 0,
        change: {
            value: "+12% 較上週",
            type: "increase",
        },
    },
    {
        value: 12,
        label: "系統範本",
        color: "#3b82f6",
        backgroundColor: "bg-white",
        icon: <LucideIcon name="PlusCircle" />,
        iconPosition: "right",
        animationDuration: 1800,
        animationDelay: 200,
        change: {
            value: "+12% 較上週",
            type: "increase",
        },
    },
    {
        value: 12,
        label: "系統範本",
        color: "#3b82f6",
        backgroundColor: "bg-white",
        icon: <LucideIcon name="PlusCircle" />,
        iconPosition: "right",
        animationDuration: 1800,
        animationDelay: 200,
    },
    {
        value: 12,
        label: "系統範本",
        color: "#3b82f6",
        backgroundColor: "bg-white",
        icon: <LucideIcon name="PlusCircle" />,
        iconPosition: "right",
        animationDuration: 1800,
        animationDelay: 200,
    }
    ],
    pageTitle = "管理首頁",
    createMode,
    formColumnApi,
    showBaseInfoBlock2 = false,
    showHeaderContainer = true,
    showStatsCard = true,
    showDescription = true,
    showCreateAction = true,
    showContentSection = true,
    showBaseInfoView3 = false,
    tabsData = [
        {
            key: "empty_draft",
            label: "進行中/歷史 空白建立",
            total: "0/0", // 雙數字
            badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
            apiRoute: mainApiRoute
        },
        {
            key: "ai_generated",
            label: "進行中/歷史 AI生成",
            total: "0/0",
            badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
            apiRoute: mainApiRoute
        },
        {
            key: "system_default",
            label: "進行中/歷史 系統預設",
            total: "5/0/500", // 三段數字
            badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
            apiRoute: mainApiRoute
        }],
    onSelectTabKey = () => { },
    PreviewModal = {},
    showTreeFilter = false,
    FilterComponent = <></>,
    multipleEditComponent = <></>,
    showCardContent = false,
    FilterComponentCols = 6,
    CardContentData = <></>,
    importButton = false,
    propsToolbars = ['patch', 'delete'],
    propsStateMode = 'stats',
    // 當 propsStateMode === "form_value" 時，用來過濾要顯示哪些欄位的 code。
    // 預設為空陣列代表顯示所有欄位。
    formValueStatsCodes = [],
    setRecord = () => { },
    setOpenFormModal,
    setAxiosMode,
    extraButtonRender = (value) => { return [] },
    setOpenCashRealTimeModal,
    setOpenCashRefundModal,
    setOpenCashManagementModal,
    setOpenCashHistoryModal,
    buttonGroupsColumnsCount,
    keyPrefix = "", // 為了讓同一個頁面多個元件可以區分開來使用
    extraButtonRenderBeforeDelete = (value) => { return [] },
    rowKey,
    propsDescription = null,
    ...props
}) => {
    const navigate = useNavigate()
    const dbName = dbCoverIdName ? dbCoverIdName.replace('_id', '') : '' //為了在post 資料的時候可以通用 ${dbName}_document_x_document_data
    const [reloadCount, setReloadCount] = useState(0)
    const [reloadAndResetCount, setReloadAndResetCount] = useState(0)
    // Defensive helper: ensure we return a readable string for many data types
    const safeLabel = (v) => {
        if (v === undefined || v === null) return propsFallbackText
        if (typeof v === 'string') return v
        if (typeof v === 'number' || typeof v === 'boolean') return String(v)
        if (Array.isArray(v)) return v.map(item => safeLabel(item)).join(', ')
        try {
            return JSON.stringify(v)
        } catch (e) {
            return String(v)
        }
    }

    const { t } = useTranslation("translation", { keyPrefix })
    const actionTextConfig = {
        create: t('建立'),
        edit: t('編輯'),
        testConnection: t('查看測試連接'),
        cashRealTime: t('即時詳細資訊'),
        cashRefund: t('退款詳細資訊'),
        cashManagement: t('查看詳細資料'),
        cashHistory: t('查看歷史詳細資料'),
        operationColumnTitle: propsOperationColumnTitle,
        ...propsActionTextConfig,
    }
    const feedbackTextConfig = {
        createSuccess: t('新增成功'),
        createError: t('新增失敗'),
        patchSuccess: t('修改成功'),
        patchError: t('修改失敗'),
        deleteSuccess: t('刪除成功'),
        deleteError: t('刪除失敗'),
        ...propsFeedbackTextConfig,
    }
    const getBaseCardViewData = (data) => {
        let newdata = data?.map((value) => {
            // 兩種資料結構 一種是 document_data 一種是 response_form_value_data
            //document_data 
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_value
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)
            let response_form_value_data = value?.response_form_value_data || []
            const result = convertResponsesToFormColumnMap([value], MainApiController?.ResponseData?.find(item => item?.document_id === value?.document_response_data?.find(_ => true)?.document_id)?.document_classify_structure_type_data);
            let nameByCode = undefined;
            let descriptionByCode = undefined;
            // 將 response_form_value_data 轉成可顯示於卡片上的 stats
            let fieldStats = response_form_value_data.map((value) => {
                let form_column_form_value_data = value?.form_column_form_value_data || []
                let form_column_form_value_data_first = form_column_form_value_data?.find((_) => true)
                let code = form_column_form_value_data_first?.code
                let res_form_column_value = value?.value?.value
                if (code === propsNameFieldCode) {
                    nameByCode = res_form_column_value
                    return null
                }
                if (code === propsDescriptionFieldCode) {
                    descriptionByCode = res_form_column_value
                    return null
                }
                return {
                    value: code,
                    // label: prefer mapped result, fallback to raw response value; use safeLabel to guard non-string types
                    label: safeLabel(getValueByCode({
                        code,
                        response_form_value_data
                    })),
                    backgroundColor: "bg-blue-50",
                }
            }).filter(Boolean)
            // 若有傳入 formValueStatsCodes，則僅顯示符合 code 陣列的項目；否則顯示全部
            const filteredFieldStats =
                Array.isArray(formValueStatsCodes) && formValueStatsCodes.length > 0
                    ? fieldStats.filter(stat => formValueStatsCodes.includes(stat.value))
                    : fieldStats
            //取得縮圖file_id
            let document_file_data = document_classify_structure_type_data_first?.document_file_data || []
            let document_file_data_first = document_file_data?.find((ele) => true)
            let file_id = propsGetCardFileId?.(value) ? propsGetCardFileId?.(value) : document_file_data_first?.cover_image_file_id
            let baseCardView1_2Props = {}
            if (!!file_id) {
                baseCardView1_2Props = {
                    src: null,
                    file_id: file_id
                }
            }
            else {
                baseCardView1_2Props = {
                    src: baseCardView1_2PropsSrc,
                    file_id: null
                }
            }
            return {
                key: value?.key,
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    ...baseCardView1_2Props
                },
                baseCardView1_3Props: {
                    value: twName || nameByCode || propsFallbackText,
                },
                baseCardView1_4Props: {
                    value: document_classify_structure_type_data_first?.document_description || descriptionByCode || propsFallbackText,
                },
                baseCardView1_5Props: {
                    //document_data 
                    ...(propsStateMode === "stats" ?
                        {
                            stats: [],
                            // stats: [
                            //     {
                            //         value: document_classify_structure_type_data_first?.view_times,
                            //         label: "瀏覽次數",
                            //         backgroundColor: "bg-blue-50",
                            //         animationDuration: 2000,
                            //         animationDelay: 0,
                            //         icon: <LucideIcon name={"Eye"} className="w-4 h-4  text-blue-500" />
                            //     },
                            //     {
                            //         value: document_classify_structure_type_data_first?.clone_times,
                            //         label: "撰寫" + propsCategoryTitle,
                            //         backgroundColor: "bg-green-50",
                            //         animationDuration: 1500,
                            //         animationDelay: 200,
                            //         icon: <LucideIcon name={"FileText"} className="w-4 h-4  text-blue-500" />,
                            //     },
                            //     {
                            //         value: document_classify_structure_type_data_first?.click_times,
                            //         label: "點擊次數",
                            //         backgroundColor: "bg-blue-50",
                            //         animationDuration: 2000,
                            //         animationDelay: 0,
                            //         icon: <LucideIcon name={"MousePointer"} className="w-4 h-4  text-purple-500" />

                            //     },
                            //     {
                            //         value: document_classify_structure_type_data_first?.copy_times,
                            //         label: "複製次數",
                            //         backgroundColor: "bg-green-50",
                            //         animationDuration: 1500,
                            //         animationDelay: 200,
                            //         icon: <LucideIcon name={"TrendingUp"} className="w-4 h-4  text-orange-500" />

                            //     },
                            // ]
                            //response_form_value_data
                            // stats: stats
                        } : {}),
                    ...(propsStateMode === "form_value" ?
                        {
                            stats: filteredFieldStats
                        } : {}),
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: value?.create_user_name ? value?.create_user_name : document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(document_classify_structure_type_data_first?.create_time).format(propsDateFormat),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    children: propsRenderCardExtraContent?.(value) ?? <></>
                },
                baseCardView1_8Props: {
                    buttons: [
                        // <Button variant="outline" className="flex-1">
                        //     <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                        //     查看
                        // </Button>,
                        ...(propsToolbars.includes('patch') ? [<Button
                            onClick={() => {
                                if (setOpenFormModal) {
                                    setOpenFormModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("patch")
                                } else {
                                    navigate(`${editPageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: value?.[dbCoverIdName] }))
                                }
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            {actionTextConfig.edit}{propsCategoryTitle}
                        </Button>] : []),

                        // <Button variant="ghost" size="sm">
                        //     <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                        //     分享
                        // </Button>,
                        // <Button variant="ghost" size="sm">
                        //     <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                        //     匯出
                        // </Button>,
                        ...(propsToolbars.includes('test') ? [<Button className="flex-1"
                            onClick={() => {
                                setRecord({ ...value, response_form_value_data_stats: stats })
                            }}
                        >
                            <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                            {actionTextConfig.testConnection}
                        </Button>] : []),
                        ...(propsToolbars.includes('response_delete') ? [<DeleteButton
                            onConfirm={() => {

                                responseController.deleteData([{ response_id: value?.response_id }])
                            }}
                            style={{}}
                            variant="ghost" size="sm" className="text-red-600"
                        />] : []),
                        ...extraButtonRenderBeforeDelete(value, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount),
                        ...(propsToolbars.includes('delete') ? [<DeleteButton
                            onConfirm={() => {
                                function extractSimplifiedData({ data, dbName, dbCoverIdName }) {
                                    return [
                                        {
                                            classify_structure_type_id: data?.classify_structure_type_id,
                                            document_classify_structure_type_data: data?.document_classify_structure_type_data.map(doc => ({
                                                document_id: doc.document_id,
                                                [`${dbName}_x_document_data`]: doc?.[`${dbName}_x_document_data`]?.map(h => ({
                                                    [`${dbCoverIdName}`]: h?.[dbCoverIdName]
                                                }))
                                            }))
                                        }
                                    ]
                                }

                                let temp = extractSimplifiedData({ data: value, dbName: dbName, dbCoverIdName: dbCoverIdName })
                                MainApiController.deleteData(temp)
                            }}
                            style={{}}
                            variant="ghost" size="sm" className="text-red-600"
                        />] : []),
                        ...(propsToolbars.includes('cash_real_time') ? [<Button
                            onClick={() => {
                                if (setOpenCashRealTimeModal) {
                                    setOpenCashRealTimeModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashRealTime}
                        </Button>] : []),
                        ...(propsToolbars.includes('cash_refund') ? [<Button
                            onClick={() => {
                                if (setOpenCashRefundModal) {
                                    setOpenCashRefundModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashRefund}
                        </Button>] : []),
                        ...(propsToolbars.includes('cash_management') ? [<Button
                            onClick={() => {
                                if (setOpenCashManagementModal) {
                                    setOpenCashManagementModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashManagement}
                        </Button>] : []),
                        ...(propsToolbars.includes('cash_history') ? [<Button
                            onClick={() => {
                                if (setOpenCashHistoryModal) {
                                    setOpenCashHistoryModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashHistory}
                        </Button>] : []),
                        ...extraButtonRender(value, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount)
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
                ...value,
            }
        })
        return newdata
    }
    const getBaseListViewData = (data) => {
        let newdata = data?.map((value) => {
            // 兩種資料結構 一種是 document_data 一種是 response_form_value_data
            //document_data 
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_value
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)

            // response_form_value_data
            let response_form_value_data = value?.response_form_value_data || []
            let nameByCode = undefined;
            let descriptionByCode = undefined;
            let fieldStats = response_form_value_data.map((value) => {
                let form_column_form_value_data = value?.form_column_form_value_data || []
                let form_column_form_value_data_first = form_column_form_value_data?.find((_) => true)
                let code = form_column_form_value_data_first?.code
                let res_form_column_value = value?.value?.value
                if (code === propsNameFieldCode) {
                    nameByCode = res_form_column_value
                    return null
                }
                if (code === propsDescriptionFieldCode) {
                    descriptionByCode = res_form_column_value
                    return null
                }
                return {
                    value: code,
                    // label: prefer mapped result, fallback to raw response value; use safeLabel to guard non-string types
                    label: safeLabel(getValueByCode({
                        code,
                        response_form_value_data
                    })),
                    backgroundColor: "bg-blue-50",
                }
            }).filter(Boolean)
            // 若有傳入 formValueStatsCodes，則僅顯示符合 code 陣列的項目；否則顯示全部
            const filteredFieldStats =
                Array.isArray(formValueStatsCodes) && formValueStatsCodes.length > 0
                    ? fieldStats.filter(stat => formValueStatsCodes.includes(stat.value))
                    : fieldStats
            return {
                key: "1",
                baseListView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseListView1_2Props: {
                    value: twName || nameByCode || propsFallbackText,
                },
                baseListView1_3Props: {
                    value: document_classify_structure_type_data_first?.document_description || descriptionByCode || propsFallbackText,
                },
                baseListView1_4Props: {
                    //document_data 
                    ...(propsStateMode === "stats" ?
                        {
                            stats: [],
                        } : {}),
                    ...(propsStateMode === "form_value" ?
                        {
                            stats: filteredFieldStats
                        } : {}),
                },
                baseListView1_5Props: {
                    badges: [
                        {
                            label: value?.create_user_name ? value?.create_user_name : document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(document_classify_structure_type_data_first?.create_time).format(propsDateFormat),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseListView1_6Props: {
                    children: propsRenderListExtraContent?.(value) ?? <></>
                },
                baseListView1_7Props: {
                    buttons: [
                        // <Button variant="outline" className="flex-1">
                        //     <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                        //     查看
                        // </Button>,
                        ...(propsToolbars.includes('patch') ? [<Button
                            onClick={() => {
                                if (setOpenFormModal) {
                                    setOpenFormModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("patch")
                                } else {
                                    navigate(`${editPageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: value?.[dbCoverIdName] }))
                                }

                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            {actionTextConfig.edit}{propsCategoryTitle}
                        </Button>] : []),
                        // <Button variant="ghost" size="sm">
                        //     <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                        //     分享
                        // </Button>,
                        // <Button variant="ghost" size="sm">
                        //     <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                        //     匯出
                        // </Button>,
                        ...extraButtonRender(value, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount),
                        ...(propsToolbars.includes('response_delete') ? [<DeleteButton
                            onConfirm={() => {

                                responseController.deleteData([{ response_id: value?.response_id }])
                            }}
                            style={{}}
                            variant="ghost" size="sm" className="text-red-600"
                        />] : []),
                        ...(propsToolbars.includes('delete') ? [<DeleteButton
                            onConfirm={() => {

                                function extractSimplifiedData({ data, dbName, dbCoverIdName }) {
                                    return [
                                        {
                                            classify_structure_type_id: data?.classify_structure_type_id,
                                            document_classify_structure_type_data: data?.document_classify_structure_type_data.map(doc => ({
                                                document_id: doc.document_id,
                                                [`${dbName}_x_document_data`]: doc?.[`${dbName}_x_document_data`]?.map(h => ({
                                                    [`${dbCoverIdName}`]: h?.[dbCoverIdName]
                                                }))
                                            }))
                                        }
                                    ]
                                }

                                let temp = extractSimplifiedData({ data: value, dbName: dbName, dbCoverIdName: dbCoverIdName })
                                MainApiController.deleteData(temp)
                            }}
                            style={{}}
                            variant="ghost" size="sm" className="text-red-600"
                        />] : []),
                        ...(propsToolbars.includes('cash_real_time') ? [<Button
                            onClick={() => {
                                if (setOpenCashRealTimeModal) {
                                    setOpenCashRealTimeModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashRealTime}
                        </Button>] : []),
                        ...(propsToolbars.includes('cash_refund') ? [<Button
                            onClick={() => {
                                if (setOpenCashRefundModal) {
                                    setOpenCashRefundModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashRefund}
                        </Button>] : []),
                        ...(propsToolbars.includes('cash_management') ? [<Button
                            onClick={() => {
                                if (setOpenCashManagementModal) {
                                    setOpenCashManagementModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashManagement}
                        </Button>] : []),
                        ...(propsToolbars.includes('cash_history') ? [<Button
                            onClick={() => {
                                if (setOpenCashHistoryModal) {
                                    setOpenCashHistoryModal(true)
                                    setRecord({
                                        ...value,
                                        responseValue: value,
                                        response_form_value_data_stats: stats
                                    })
                                    setAxiosMode("get")
                                }
                            }}
                            className="flex-1">
                            {actionTextConfig.cashHistory}
                        </Button>,

                        ] : []),
                    ],
                    buttonGroupsColumnsCount: buttonGroupsColumnsCount ?? [2, 3],
                },
                ...value,
            }
        })
        return newdata
    }

    const MainApiController = useCRUDController({
        apiRoute: mainApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success(feedbackTextConfig.createSuccess)
                    setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success(feedbackTextConfig.patchSuccess)
                    setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success(feedbackTextConfig.deleteSuccess)
                    setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error(feedbackTextConfig.createError)
                    setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error(feedbackTextConfig.patchError)
                    setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error(feedbackTextConfig.deleteError)
                    setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
                // setModalOpen(false);
            }
        }
    })
    const responseController = useCRUDController({
        apiRoute: responseApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success(feedbackTextConfig.createSuccess)
                    setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success(feedbackTextConfig.patchSuccess)
                    setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success(feedbackTextConfig.deleteSuccess)
                    setReloadAndResetCount((pre) => pre + 1)
                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error(feedbackTextConfig.createError)
                    setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error(feedbackTextConfig.patchError)
                    setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error(feedbackTextConfig.deleteError)
                    setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
                // setModalOpen(false);
            }
        }
    })
    return (
        <Row>
            <Col span={24}>
                <CrmDashboard
                    rowKey={rowKey}
                    createMode={createMode}
                    createButtontext={propsCreateButtonText ?? `${propsCategoryName}${propsCategoryTitle}${actionTextConfig.create}`}
                    createApiRoute={createApiRoute}
                    apiRoute={mainApiRoute}
                    getBaseCardViewData={propsGetBaseCardViewData ? propsGetBaseCardViewData : getBaseCardViewData}
                    getBaseListViewData={propsGetBaseListViewData ? propsGetBaseListViewData : getBaseListViewData}

                    primaryColor={propsPrimaryColor}
                    secondColor={propsSecodaryColor}
                    pageTitleColor={propsPageTitleColor}
                    pageTitleFontSize={propsPageTitleFontSize}
                    pageTitleFontWeight={propsPageTitleFontWeight}
                    pageTitleLineHeight={propsPageTitleLineHeight}
                    createButtonTextColor={propsCreateButtonTextColor}
                    createButtonFontSize={propsCreateButtonFontSize}
                    createButtonFontWeight={propsCreateButtonFontWeight}
                    descriptionColor={propsDescriptionColor}
                    descriptionFontSize={propsDescriptionFontSize}
                    descriptionLineHeight={propsDescriptionLineHeight}
                    showCreateButtontext={showCreateButtontext}
                    propsReloadCount={props.propsReloadCount !== undefined ? props.propsReloadCount : reloadCount}
                    propsSetReloadCount={props.propsSetReloadCount !== undefined ? props.propsSetReloadCount : setReloadCount}
                    propsReloadAndResetCount={props.propsReloadAndResetCount !== undefined ? props.propsReloadAndResetCount : reloadAndResetCount}
                    propsSetReloadAndResetCount={props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount}
                    stats={stats}
                    pageTitle={pageTitle}
                    baseCardView1_2PropsSrc={baseCardView1_2PropsSrc}
                    formColumnApi={formColumnApi}
                    showBaseInfoBlock2={showBaseInfoBlock2}
                    showHeaderContainer={showHeaderContainer}
                    showStatsCard={showStatsCard}
                    showDescription={showDescription}
                    showCreateAction={showCreateAction}
                    showContentSection={showContentSection}
                    showBaseInfoView3={showBaseInfoView3}
                    tabsData={tabsData}
                    onSelectTabKey={(e) => {
                        onSelectTabKey(e)
                    }}
                    PreviewModal={PreviewModal}
                    showTreeFilter={showTreeFilter}
                    FilterComponent={FilterComponent}
                    multipleEditComponent={multipleEditComponent}
                    showCardContent={showCardContent}
                    FilterComponentCols={FilterComponentCols}
                    CardContentData={CardContentData}
                    importButton={importButton}
                    treeFilterTitle={treeFilterTitle}
                    searchTextConfig={searchTextConfig}
                    viewModeTextConfig={viewModeTextConfig}
                    categoryTabTextConfig={categoryTabTextConfig}
                    {...props}
                    proptableDefaultProps={{
                        columns: [
                            ...props?.proptableDefaultProps?.columns || [],
                            ...(propsToolbars || []).length > 0 ? [{
                                title: actionTextConfig.operationColumnTitle,
                                dataIndex: 'option',
                                valueType: 'option',
                                fixed: 'right',
                                width: propsOperationColumnWidth,
                                render: (text, record, index) => {
                                    return (
                                        <div className="flex gap-2">
                                            <BaseCardView1_8
                                                buttons={[
                                                    // <Button variant="outline" className="flex-1">
                                                    //     <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                                                    //     查看
                                                    // </Button>,
                                                    ...(propsToolbars.includes('patch') ? [<Button
                                                        onClick={() => {
                                                            if (setOpenFormModal) {
                                                                setOpenFormModal(true)
                                                                setRecord({
                                                                    ...record,
                                                                    responseValue: record,
                                                                    response_form_value_data_stats: stats
                                                                })
                                                                setAxiosMode("patch")
                                                            } else {
                                                                navigate(`${editPageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: record?.[dbCoverIdName] }))
                                                            }
                                                        }}
                                                        className="flex-1">
                                                        <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                                                        {actionTextConfig.edit}{propsCategoryTitle}
                                                    </Button>] : []),
                                                    // <Button variant="ghost" size="sm">
                                                    //     <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                                                    //     分享
                                                    // </Button>,
                                                    // <Button variant="ghost" size="sm">
                                                    //     <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                                                    //     匯出
                                                    // </Button>,
                                                    ...(propsToolbars.includes('test') ? [<Button className="flex-1"
                                                        onClick={() => {
                                                            setRecord({ ...record?.responseValue, response_form_value_data_stats: stats })
                                                        }}
                                                    >
                                                        <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                                                        {actionTextConfig.testConnection}
                                                    </Button>] : []),
                                                    ...extraButtonRenderBeforeDelete(record, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount),
                                                    ...(propsToolbars.includes('delete') ? [<DeleteButton
                                                        onConfirm={() => {

                                                            function extractSimplifiedData({ data, dbName, dbCoverIdName }) {
                                                                return [
                                                                    {
                                                                        classify_structure_type_id: data?.classify_structure_type_id,
                                                                        document_classify_structure_type_data: (data?.document_classify_structure_type_data || [])?.map(doc => ({
                                                                            document_id: doc.document_id,
                                                                            [`${dbName}_x_document_data`]: doc?.[`${dbName}_x_document_data`]?.map(h => ({
                                                                                [`${dbCoverIdName}`]: h?.[dbCoverIdName]
                                                                            }))
                                                                        }))
                                                                    }
                                                                ]
                                                            }

                                                            let temp = extractSimplifiedData({ data: record?.responseValue, dbName: dbName, dbCoverIdName: dbCoverIdName })
                                                            MainApiController.deleteData(temp)
                                                        }}
                                                        style={{}}
                                                        variant="ghost" size="sm" className="text-red-600"
                                                    />] : []),

                                                    ...(propsToolbars.includes('response_delete') ? [<DeleteButton
                                                        onConfirm={() => {
                                                            responseController.deleteData([{ response_id: record?.response_id }])
                                                        }}
                                                        style={{}}
                                                        variant="ghost" size="sm" className="text-red-600"
                                                    />] : []),
                                                    ...(propsToolbars.includes('cash_real_time') ? [<Button
                                                        onClick={() => {
                                                            if (setOpenCashRealTimeModal) {
                                                                setOpenCashRealTimeModal(true)
                                                                setRecord({
                                                                    ...record?.responseValue,
                                                                    responseValue: record?.responseValue,
                                                                    response_form_value_data_stats: stats
                                                                })
                                                                setAxiosMode("get")
                                                            }
                                                        }}
                                                        className="flex-1">
                                                        {actionTextConfig.cashRealTime}
                                                    </Button>] : []),
                                                    ...(propsToolbars.includes('cash_refund') ? [<Button
                                                        onClick={() => {
                                                            if (setOpenCashRefundModal) {
                                                                setOpenCashRefundModal(true)
                                                                setRecord({
                                                                    ...record?.responseValue,
                                                                    responseValue: record?.responseValue,
                                                                    response_form_value_data_stats: stats
                                                                })
                                                                setAxiosMode("get")
                                                            }
                                                        }}
                                                        className="flex-1">
                                                        {actionTextConfig.cashRefund}
                                                    </Button>] : []),
                                                    ...(propsToolbars.includes('cash_management') ? [<Button
                                                        onClick={() => {
                                                            if (setOpenCashManagementModal) {
                                                                setOpenCashManagementModal(true)
                                                                setRecord({
                                                                    ...record?.responseValue,
                                                                    responseValue: record?.responseValue,
                                                                    response_form_value_data_stats: stats
                                                                })
                                                                setAxiosMode("get")
                                                            }
                                                        }}
                                                        className="flex-1">
                                                        {actionTextConfig.cashManagement}
                                                    </Button>] : []),
                                                    ...(propsToolbars.includes('cash_history') ? [<Button
                                                        onClick={() => {
                                                            if (setOpenCashHistoryModal) {
                                                                setOpenCashHistoryModal(true)
                                                                setRecord({
                                                                    ...record?.responseValue,
                                                                    responseValue: record?.responseValue,
                                                                    response_form_value_data_stats: stats
                                                                })
                                                                setAxiosMode("get")
                                                            }
                                                        }}
                                                        className="flex-1">
                                                        {actionTextConfig.cashHistory}
                                                    </Button>] : []),
                                                    ...extraButtonRender(record?.responseValue, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount)
                                                ]}
                                            />
                                        </div>
                                    );
                                },
                            }] : []
                        ]
                    }}
                    propsDescription={propsDescription}
                />
            </Col>
        </Row>
    )
}
export default Name1
